

<template>
  <section style="padding-bottom:15px;">
    <header class="detail-title">Amazon发运明细</header>
    <Table style="margin:0 16px"
           :columns="columns"
           :data="data"
           size="small"
           ref="table"
           border
           stripe></Table>
    <div class="color-error padding-left-15 padding-top-5">手动添加并保存的发运明细会自动推送给云仓，请谨慎操作!</div>
    <footer class="text-center bg-fff padding-top-15"
            v-if="type!=='query'">
      <Button type="primary"
              class="width-15per"
              @click="submit">保存</Button>
      <Button class="width-15per"
              @click="show=true">添加</Button>
      <Button class="width-15per"
              @click="cancel">取消</Button>
    </footer>
    <Modal class="hidefooter"
           v-model='show'
           :mask-closable='false'
           title="Amazon发运明细"
           :width="720">
      <compShipDetail v-if="show"
                      @on-close="show=false"
                      :data='formData'
                      @on-update="updateItem" />
      <footer slot="footer"
              v-show="false"></footer>
    </Modal>
    <Spin size="large"
          fix
          v-if="loading"></Spin>
  </section>
</template>

<script>
import { HttpUpdateAllotShipping } from '@/service/allotment/transfer';
import compShipDetail from './shipDetail'
import { Button } from 'view-design';
export default {
  props: ['value', 'id', 'type'],
  components: {
    compShipDetail
  },
  data () {
    return {
      data: [],
      loading: false,
      status: this.$route.query.status,
      formData: {},
      show: false,
      index: -1,
      required: [{
        required: true,
        message: "该信息不能为空,请填写"
      }],
    };
  },

  watch: {
    value () {
      this.data = this.value;
    },
    show (val) {
      if (!val) {
        this.index = -1;
        this.formData = {};
      }
    }
  },

  methods: {
    updateItem (val) {
      if (this.index >= 0) {
        this.$set(this.data, this.index, val);
        this.index = -1;
      } else {
        this.data.push(val);
      }
      this.formData = {};
    },
    getItem (index) {
      this.show = true;
      this.index = index;
      this.formData = this.data[index];
    },
    removeItem (index) {
      this.data.splice(index, 1)
    },
    handleFormat (data = []) {
      const obj = { id: this.id };
      data.forEach((item, index) => {
        Object.keys(item).forEach(function (key) {
          obj[`shippingItems[${index}].${key}`] = this[key]
        }, item)
      });
      return obj;
    },
    cancel () {
      this.$router.push({ name: "tsList" })
    },
    submit () {
      this.loading = true;
      HttpUpdateAllotShipping(this.handleFormat(this.data)).then(res => {
        this.cancel();
        this.$Message.success(res.message);
      }, err => {
        this.loading = false;
        this.$VMessage.error({
          content: err.message,
          duration: 30,
          closable: true
        });
      });
    }
  },
  computed: {
    columns () {
      const columns = [
        {
          title: 'Seller SKU',
          key: 'sellerSku',
        },
        {
          title: 'ERP SKU',
          key: 'erpSku',
        },
        {
          title: '发运数量',
          key: 'shippingNum',
        }, {
          title: '接收数量',
          key: 'inboundAmount',
        }, {
          title: 'Disposition',
          key: 'disposition',
        }, {
          title: 'Carrier',
          key: 'carrier',
        }, {
          title: 'Tracking',
          key: 'tracking',
        }, {
          title: '状态',
          key: 'shippingType',
        }, {
          title: '发货时间',
          key: 'deliveryAt',
        }, {
          title: '更新时间',
          key: 'updateTime',
        }, {
          title: '操作',
          width: 160,
          render: (h, { index, row }) => {
            if (this.status == 'outdept') {
              return <div>
                <Button disabled type="primary" class='margin-right-5' nativeOnClick={this.getItem.bind(this, index)}>编辑</Button>
                <Button disabled type="error" nativeOnClick={this.removeItem.bind(this, index)}>删除</Button>
              </div>
            } else {
              return <div>
                <Button type="primary" class='margin-right-5' nativeOnClick={this.getItem.bind(this, index)}>编辑</Button>
                <Button type="error" nativeOnClick={this.removeItem.bind(this, index)}>删除</Button>
              </div>
            }
          }
        }
      ];
      if (this.type === 'query') columns.pop();
      return columns
    },
  },
};
</script>



